<template>
  <div style="position: relative">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
          <h1 class="page-title">
            {{ screentexts[160]?screentexts[160].element_text:'Members in group:' }} <span :class="`${anon ? 'g-anon-lg' : '' }`"> {{ group.group_name }} </span>
              <!-- <PopupBubble
                v-if="screentexts[159] && screentexts[159].element_bubbletext !== '' && screentexts[159].element_bubbletext !== null"
                screenelement_id="159"
                :screen_id="screen_id"
                :bubbletext="screentexts[159]?screentexts[159].element_bubbletext:''"
              /> -->
          </h1>
        </div>
        <div v-show="group_created == true">
          <b-alert variant="success">
            Your new group has been created! You are now ready to create your survey.
          </b-alert>
        </div>
        <div v-html="screentexts[161]?screentexts[161].element_text:'<p>The members in your group are listed below. You can edit group member information, add new group members or exclude group members from this survey.</p><ul><li>Click &quot;next&quot; if the information is correct</li><li>Click on the three dots in the action column to adjust any incorrect information or exclude a group member from this survey.</li><li>Click “Add new member” If you want to add a new member to this survey (and to the group).</li></ul>'" />
        <h3 class="mt-5">{{ screentexts[162]?screentexts[162].element_text:'Group members' }}</h3>
        <b-form-group>
          <b-button
          variant="primary"
          id="add-new-member"
          @click="toggleAddMember"
          >
            Add new member
          </b-button>
        </b-form-group>
        <b-form
          class="bg-secondary add-member-container"
          v-if="isAddMemberVisible"
          novalidate
          @submit.stop.prevent
        >
          <!-- <b-form-group
            class="col-12 col-md-4 pr-0 py-0 my-0"
          >
            <label class="col-12 pl-0">
              {{ screentexts[165]?screentexts[165].element_text:'[Member] name.' }}
            </label>
            <b-form-input
              v-model="groupmember_name"
              class="col-12"
              :placeholder="screentexts[171]?screentexts[171].element_text:'[Member] Name (optional)'"
            />
            <br>&nbsp;
          </b-form-group> -->
          <!-- b-form-group
            class="col-3 pr-0"
          >
            <label class="col-12 pl-0">
              {{ screentexts[166]?screentexts[166].element_text:'Mobile Phone' }}
            </label>
            <b-form-input
              v-model="groupmember_mobile"
              class="col-12"
              :placeholder="screentexts[172]?screentexts[172].element_text:'Mobile phone number (optional)'"
            />
            <br>&nbsp;
          </b-form-group -->
          <b-form-group
            class=""
          >
            <label class="">
              {{ screentexts[167]?screentexts[167].element_text:'Form Type' }}
            </label>
            <b-form-select
              v-model="groupmember_formoption_id"
              :options="formoptions"
            />
          </b-form-group>
          <b-form-group
            :state="groupmember_email_valid"
            v-show="groupmember_formoption_id==1"
            class=""
          >
            <label class="col-12 pl-0">
              {{ screentexts[164]?screentexts[164].element_text:'Email address' }}
            </label>
            <input
              v-model="groupmember_email"
              class="form-control col-12"
              :class="`${anon ? 'g-anon' : '' }`"
              :state="groupmember_email_valid"
              type="text"
              :placeholder="screentexts[170]?screentexts[170].element_text:'Email Address'"
            >
            <span
              v-show="groupmember_email_valid == 'invalid'"
              class="text-danger"
            >Invalid or duplicate email address</span>
            <span v-show="groupmember_email_valid != 'invalid'">&nbsp;</span>
          </b-form-group>
          <b-form-group
            class="button-group mb-0"
          >
            <div class="text-right">
              <b-button
                variant="primary"
                @click.prevent="addgroupmember"
              >
                <span class="d-inline-block d-md-none d-lg-inline-block">{{ screentexts[175]?screentexts[175].element_text:'Add.' }}</span>
              </b-button>
              <b-button
                variant="danger"
                class="ml-2"
                @click="toggleAddMember"
              >
                <span class="d-inline-block d-md-none d-lg-inline-block">Cancel</span>
              </b-button>
            </div>
          </b-form-group>
        </b-form>
        <b-table
          :fields="fields"
          :class="'actions-table save-cancel'"
          :items="includedGroupMembers"
          :tbody-tr-class="rowClass"
        >
          <template v-slot:cell(actions)="data">
            <div class="d-flex justify-content-end">
              <div v-if="data.item.editable">
                <b-button variant="danger" class="btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
                <b-button variant="primary" class="btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</b-button>
              </div>
              <b-dropdown right class="ml-2">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click.prevent="togglegroupmember(data.item.id)">Exclude from this survey</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <template v-slot:cell(groupmember_code)="data">
            {{ data.item.groupmember_code }}
          </template>

          <template v-slot:cell(groupmember_email)="data">
            <div class="position-relative">
              <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
              <b-form-input
                  v-else
                  v-model="data.item.groupmember_email"
                  type="text"
                  :class="{'g-anon': anon, 'text-danger': data.item.groupmember_email_valid == 'invalid'}"
                />
                <i
                  v-if="data.item.groupmember_email_valid == 'invalid' && data.item.editable"
                  class="fa-solid inline-tooltip fa-circle-question tooltip-question tooltip-danger"
                  v-b-tooltip="'Invalid email address'"
                ></i>
            </div>
          </template>
          <!-- <template v-slot:cell(groupmember_name)="data">
            <b-form-input
              v-model="data.item.groupmember_name"
              type="text"
            />
          </template> -->
          <template v-slot:cell(groupmember_mobile)="data">
            <b-form-input
              v-model="data.item.groupmember_mobile"
              type="text"
            />
          </template>

          <template v-slot:cell(groupsurveymember_formoption_id)="data">
            <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
            <b-form-select v-else v-model="data.item.groupsurveymember_formoption_id" :options="formoptions" />
          </template>

        </b-table>

        <h3 class="mt-5 mb-3">
          Members not included in this survey
        </h3>

        <b-table
          :fields="fields"
          :class="'actions-table save-cancel excluded'"
          :items="excludedGroupMembers"
          :tbody-tr-class="rowClass"
        >
          <template v-slot:cell(actions)="data">
            <div class="d-flex justify-content-end">
              <div v-if="data.item.editable">
                <b-button variant="danger" class="btn-tiny mr-1" @click.prevent="cancelEdit(data.item.id)">Cancel</b-button>
                <b-button variant="primary" class="btn-tiny" @click.prevent="saveEdit(data.item.id)">Save</b-button>
              </div>
              <b-dropdown right class="ml-2">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <b-dropdown-item @click.prevent="editGroupMember(data.item.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click.prevent="togglegroupmember(data.item.id)">Include in this survey</b-dropdown-item>
              </b-dropdown>
            </div>
          </template>

          <template v-slot:cell(groupmember_code)="data">
            {{ data.item.groupmember_code }}
          </template>

          <template v-slot:cell(groupmember_email)="data">
            <div>
              <div class="uneditable" v-if="!data.item.editable" :class="{ 'g-anon': anon }">{{ data.item.groupmember_email }}</div>
              <b-form-input v-else v-model="data.item.groupmember_email" type="text"
                :class="{ 'g-anon': anon }"
              />
            </div>
          </template>

          <!-- <template v-slot:cell(groupmember_name)="data">
            <b-form-input
              v-model="data.item.groupmember_name"
              type="text"
            />
          </template> -->
          <template v-slot:cell(groupmember_mobile)="data">
            <b-form-input
              v-model="data.item.groupmember_mobile"
              type="text"
            />
          </template>

          <template v-slot:cell(groupsurveymember_formoption_id)="data">
            <div class="uneditable" v-if="!data.item.editable">{{ getFormOptionText(data.item.groupsurveymember_formoption_id) }}</div>
            <b-form-select v-else v-model="data.item.groupsurveymember_formoption_id" :options="formoptions" />
          </template>

        </b-table>
        <b-row />

        <div class="d-flex justify-content-between mt-5 mb-5">
            <b-link
              :to="back_url"
              class="float-left"
            >
              <b-button variant="secondary">
                &lt; Cancel
              </b-button>
            </b-link>
            <b-button
              class="float-right"
              variant="primary"
              :disabled="loading"
              @click.prevent="groupsurveymembers_create"
            >
              <span v-show="!loading">Next ></span>
              <b-spinner
                v-show="loading"
                small
              />
            </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import PopupBubble from './PopupBubble.vue'

export default {
  name: 'CreateGroupSurvey',
  components: {
    Navbar,
    Breadcrumb
    // PopupBubble,
  },
  data () {
    return {
      isAddMemberVisible: false,
      selected: null,
      fields: [
        { key: 'groupmember_code', label: 'Member', tdClass: 'd-none d-sm-table-cell', thClass: 'd-none d-sm-table-cell' },
        { key: 'groupmember_email', label: 'Email', class: 'editable email-column' },
        // { key: 'groupmember_name', label: '[Member] name', tdClass: 'd-none d-sm-table-cell',thClass: 'd-none d-sm-table-cell'  },
        //        { key: 'groupmember_mobile', label: 'Mobile phone number', class: 'col-3 td-3' },
        { key: 'groupsurveymember_formoption_id', label: 'Form type', class: 'editable select-column' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      group_id: this.$store.state.currentgroup_id,
      currentgroupmembers: this.$store.state.currentgroupmembers,
      survey_id: this.$store.state.currentsurvey_id,
      groupmember_name: '',
      groupmember_name_valid: null,
      groupmember_email: '',
      groupmember_email_valid: null,
      groupmember_mobile: '',
      groupmember_mobile_valid: null,
      groupmember_formoption_id: 1,
      groupmembers_grid: [],
      nextid: 10000000,
      group_created: null,
      back_url: null,
      screen_id: 6,
      screentexts: [],
      loading: false,
      original_member_data: {} // To store the original data before editing
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    group: {
      get () {
        return this.$store.state.currentgroup
      }
    },
    includedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey == 1)
    },
    excludedGroupMembers () {
      return this.groupmembers_grid.filter(member => member.included_in_survey == 0)
    },
    // groupmembers_db() {
    //   var currentgroupmembers = this.currentgroupmembers;
    //   return currentgroupmembers.map(member => ({
    //     ...member,
    //     editable: false // Add the editable state to each group member
    //   }));
    // },
    groupmembers_db: {
      get () {
        var currentgroupmembers = this.currentgroupmembers
        var currentsurveymembers = this.$store.state.currentsurveymembers
        var survey_id = this.$store.state.currentsurvey_id
        var groupmembers_db = []

        if (survey_id == 0) {
          for (var i = 0; i < currentgroupmembers.length; i++) {
            var currentgroupmember = currentgroupmembers[i]
            var m = {
              id: currentgroupmember.id,
              groupmember_code: currentgroupmember.groupmember_code,
              groupmember_name: currentgroupmember.groupmember_name,
              groupmember_email: currentgroupmember.groupmember_email,
              groupmember_mobile: currentgroupmember.groupmember_mobile,
              groupmember_formoption_id: currentgroupmember.groupmember_formoption_id,
              groupsurveymember_formoption_id: currentgroupmember.groupmember_formoption_id,
              groupmember_status_id: currentgroupmember.groupmember_status_id,
              included_in_survey: 1,
              editable: true
            }
            groupmembers_db.push(m)
          }
        } else {
          for (let i = 0; i < currentsurveymembers.length; i++) {
            const surveymember = currentsurveymembers[i]
            let groupmember = currentgroupmembers.find(gm => gm.id === surveymember.groupmember_id)

            if (groupmember) {
              groupmember.groupsurveymember_formoption_id = surveymember.groupsurveymember_formoption_id
              groupmember.newid = surveymember.id
              groupmember.included_in_survey = surveymember.included_in_survey
              groupmember.editable = surveymember.editable
              groupmembers_db.push(groupmember)
            }
          }
        }
        return groupmembers_db
      }
    },
    formoptions: {
      get () {
        var items = this.$store.state.formoptions
        var formoptions = []
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].formoption_name
          }
          formoptions.push(option)
        }
        return formoptions
      }
    }
  },
  watch: {
    groupmembers_db () {
      this.groupmembers_grid = this.groupmembers_db.map(member => ({
        ...member,
        editable: false // Ensure to set editable state when data changes
      }))
    }
  },
  created () {
    this.screentexts_get()
    this.formoptions_get()
    this.group_get()
    this.groupmembers_get()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name == 'creategroupmembers') {
        vm.group_created = true
        vm.back_url = from.path
      } else {
        vm.group_created = false
        vm.back_url = '/group'
      }
      next()
    })
  },
  beforeRouteLeave (to, from, next) {
    // ---------------------------------------------------------------------------
    // We are going forward - save, I wonder should I change "create" to "save" ?
    // ---------------------------------------------------------------------------
    if (to.name == 'creategroupsurveydetails') {
      //      this.groupsurveymembers_create();
    }
    next()
  },
  methods: {
    rowClass (item, index) {
      return item.editable ? 'editable-row' : ''
    },
    toggleAddMember () {
      this.isAddMemberVisible = !this.isAddMemberVisible
    },
    editGroupMember (id) {
      for (let i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id === id) {
          if (this.groupmembers_grid[i].editable) {
            this.groupmembers_grid[i].editable = false
          } else {
            // Cancel edit for all other rows
            this.groupmembers_grid.forEach((member, index) => {
              if (index !== i) {
                this.cancelEdit(member.id)
              }
            })
            this.groupmembers_grid[i].editable = true
            this.original_member_data[id] = JSON.parse(JSON.stringify(this.groupmembers_grid[i]))
          }
        }
      }
    },
    cancelEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1 && this.original_member_data[id]) {
        this.groupmembers_grid[index].groupmember_code = this.original_member_data[id].groupmember_code
        this.groupmembers_grid[index].groupmember_email = this.original_member_data[id].groupmember_email
        this.groupmembers_grid[index].groupmember_mobile = this.original_member_data[id].groupmember_mobile
        this.groupmembers_grid[index].groupmember_formoption_id = this.original_member_data[id].groupmember_formoption_id
        this.groupmembers_grid[index].groupsurveymember_formoption_id = this.original_member_data[id].groupsurveymember_formoption_id
        this.groupmembers_grid[index].groupmember_status_id = this.original_member_data[id].groupmember_status_id
        this.groupmembers_grid[index].included_in_survey = this.original_member_data[id].included_in_survey
        this.groupmembers_grid[index].editable = false
        delete this.original_member_data[id]
      }
    },

    saveEdit (id) {
      const index = this.groupmembers_grid.findIndex(member => member.id === id)
      if (index !== -1) {
        const member = this.groupmembers_grid[index]
        if (this.validateEditedMember(member)) {
          member.editable = false
          delete this.original_member_data[id]
          this.updatesurvey(false)
        } else {
          member.groupmember_email_valid = 'invalid'
          const mail = member.groupmember_email
          member.groupmember_email = ''
          member.groupmember_email = mail
        }
      }
    },

    validateEditedMember (member) {
      if (member.groupsurveymember_formoption_id != 1) {
        member.groupmember_email_valid = null
        member.groupmember_email = ''
        return true
      } else {
        return this.parse_email(member.groupmember_email)
      }
    },

    getFormOptionText (id) {
      const option = this.formoptions.find(option => option.value === id)
      return option ? option.text : ''
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    groupsurveymembers_create () {
      this.loading = true
      var data = {
        group_id: this.$store.state.currentgroup_id,
        survey_id: this.$store.state.currentsurvey_id,
        groupmembers: this.groupmembers_grid,
        group: this.$store.state.currentgroup
      }
      this.$store.dispatch('groupsurveymembers_create', data)
        .then((resp) => {
          this.group_id = resp.data.group_id
          this.survey_id = resp.data.survey_id
          this.$store.dispatch('groupsurvey_setcurrent', { survey_id: this.survey_id })
            .then((resp) => {
              this.$store.dispatch('group_setcurrent', { group_id: this.group_id })
                .then((resp) => {
                  this.$store.dispatch('groupsurvey_setcurrent', { survey_id: this.survey_id })
                    .then((resp) => {
                      this.$router.push('/create/group/survey/details')
                    })
                })
            })
        })
    },
    togglegroupmember (id) {
      for (var i = 0; i < this.groupmembers_grid.length; i++) {
        if (this.groupmembers_grid[i].id == id) {
          if (this.groupmembers_grid[i].included_in_survey == 1) {
            this.groupmembers_grid[i].included_in_survey = 0
          } else {
            this.groupmembers_grid[i].included_in_survey = 1
          }
          this.updatesurvey(false)
        }
      }
    },
    cleargroupmember () {
      this.groupmember_name = ''
      this.groupmember_email = ''
      this.groupmember_mobile = ''
    },
    validategroupmember () {
      var formok = true
      this.groupmember_name_valid = null
      this.groupmember_email_valid = null
      this.groupmember_mobile_valid = null
      // Online form
      if (this.groupmember_formoption_id == 1) {
        if (this.groupmember_email == '') {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
        // eslint-disable-next-line
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.groupmember_email) == false) {
        if (!this.parse_email(this.groupmember_email)) {
          this.groupmember_email_valid = 'invalid'
          formok = false
        }
      }
      return formok
    },
    updatesurvey (adding) {
      var newmember = {
        id: this.nextid, // id
        groupmember_code: '', // groupmember_code
        groupmember_name: this.groupmember_name,
        groupmember_email: this.groupmember_email,
        groupmember_mobile: this.groupmember_mobile,
        groupmember_formoption_id: this.groupmember_formoption_id,
        groupsurveymember_formoption_id: this.groupmember_formoption_id,
        groupmember_status_id: 0,
        included_in_survey: true,
        newid: 0,
        _rowVariant: 'success'
      }
      if (newmember != null && adding) {
        this.nextid++
        this.cleargroupmember()
        this.groupmembers_grid.push(newmember)
        var data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('addingsurveymember_set', {
          addingsurveymember: true
        })
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          console.log('Getting 1 ', this.survey_id)
          this.survey_get(this.survey_id)
        })
      } else {
        var data = {
          group_id: this.$store.state.currentgroup_id,
          survey_id: this.$store.state.currentsurvey.id,
          groupmembers: this.groupmembers_grid,
          group: this.$store.state.currentgroup
        }
        this.$store.dispatch('groupsurveymembers_create', data).then(() => {
          console.log('Getting 2 ', this.survey_id)
          this.survey_get(this.survey_id)
        })
      }
    },
    survey_get: function (id) {
      this.has_paper = 0
      this.has_mail = 0
      this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id }).then((resp) => {
        this.survey = resp.data
        this.$store.dispatch('groupsurveymembers_fetch', { survey_id: id })
          .then((resp) => {
            var members = resp.data.result
            this.currentsurveymembers = members
            for (var i = 0; i < members.length; i++) {
              if (members[i].groupsurveymember_formoption_id === 1) { this.has_mail = 1 }
              if (members[i].groupsurveymember_formoption_id === 2) { this.has_paper = 1 }
              members[i].editable = false
            }
            if (this.survey.survey_status_id == 1) {
              var data = {
                id: this.$store.state.currentsurvey.id,
                survey_status_id: 2
              }
              this.$store.dispatch('groupsurvey_save', { survey: data })
                .then(() => {
                  this.$store.dispatch('groupsurvey_fetch', { id: this.survey.id }).then((resp) => {
                    this.survey = resp.data
                  })
                })
            }
          })
      })
    },
    addgroupmember () {
      if (this.validategroupmember()) {
        this.updatesurvey(true)
      }
    },
    formoptions_get: function () {
      this.$store.dispatch('formoptions_fetch')
    },
    group_get: function () {
      this.$store.dispatch('group_fetch')
        .then(() => {
          this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id })
        })
    },
    groupmembers_get: async function () {
      this.$store.dispatch('groupmembers_fetch', { group_id: this.$store.state.currentgroup_id }).then((resp) => {
        this.currentgroupmembers = resp.data.result.map(member => ({
          ...member,
          editable: false // Add the editable state to each group member
        }))
      })
    }
  }
}
</script>
<style>
.td-2 {
  width: 16%;
}
.td-3 {
  width: 25%;
}
.add-member-container {
  padding: 30px;
  margin-bottom: 1.5rem;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
